/*
 * General utils for managing cookies in Typescript.
 */
export function setCookie(name: string, val: string) {
   const date = new Date();
   const value = val;

   // Set it expire in 7 days
   date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));

   // Set it
   document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}

export function getCookie(name: string): string | null {
   const value = "; " + document.cookie;
   const parts = value.split("; " + name + "=");

   if (parts && parts.length == 2) {
      return parts.pop()!.split(";").shift() ?? null;
   } else {
      return null;
   }
}

export function deleteCookie(name: string) {
   const date = new Date();

   // Delete by setting it to expire in -1 days
   date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

   // Set it
   document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
}